import { AppRouteRecordRaw } from '../types';
import { PARTNER_TYPES } from '@/constants/partner-types';
import { getUserAddDataFromLocalStorage } from '@/utils/userUtils';

const Body = () => import('@/components/body.vue');

function redirectOrderDetailsByPartnerType(to: any) {
  const { userAddData, partnerTypes, partnerSettings } = getUserAddDataFromLocalStorage();
  const query = { ...to.query };

  if (!userAddData) {
    return {
      path: '/auth/login',
      query: {
        unauthorized: 'true',
        redirect: to.fullPath,
      },
    };
  }

  if (partnerSettings?.useFleetApis === true) {
    return {
      name: 'PartnerFleetOperationOrderDetail',
      query,
      hash: to.hash,
    };
  }

  if (Array.isArray(partnerTypes) && partnerTypes.includes(PARTNER_TYPES.FLEET_PARTNER)) {
    return {
      name: 'fleetTransactionDetail',
      query,
      hash: to.hash,
    };
  }

  return {
    path: '/unauthorized',
    query: { reason: 'auth' },
  };
}

/**
 * Shared partner-type-agnostic deeplinks. After authentication, each route
 * redirects to the concrete page for the logged-in user's partner type.
 */
export const deeplinkRoutes: AppRouteRecordRaw[] = [
  {
    path: '/deeplinks',
    component: Body,
    meta: {
      requiresAuth: true,
      breadcrumb: 'Deeplinks',
    },
    children: [
      {
        path: 'orders/order-details',
        name: 'DeeplinkOrderDetails',
        redirect: redirectOrderDetailsByPartnerType,
        meta: {
          requiresFleetOpsOrFleetPartner: true,
          title: 'Order details | ryd Portal',
          breadcrumb: 'Order details',
        },
      },
    ],
  },
];
